import { AfterChangeProps } from "@ml-pa/react-apollo-form-tool/types";
export default (d: AfterChangeProps) => {
  // console.log(d);
};
